export { default } from './Link';
export type { Props, Props as LinkCardsProps } from './Link';
